import React from 'react';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskEmployeeOnboardingConfiguration: LazyComponent<
	typeof import('@jira/spa-apps__service-desk-employee-onboarding-configuration/src/EmployeeOnboardingConfigurationView.tsx').default
> = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-employee-onboarding-configuration", jiraSpaEntry: "async-project-settings-service-desk-employee-onboarding-configuration" */ '@jira/spa-apps__service-desk-employee-onboarding-configuration/src/EmployeeOnboardingConfigurationView.tsx'
		),
	),
);

const ServicedeskEmployeeOnboardingConfigurationComponent = (): JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskEmployeeOnboardingConfiguration}
		pageId="project-settings-employee-onboarding-configuration"
		shouldShowSpinner
	/>
);

export default ServicedeskEmployeeOnboardingConfigurationComponent;
